module.exports = __webpack_public_path__ + "static/media/cadena_hidrogeno_2.24383852.PNG";